import React from 'react';
import { useCounter } from '../hooks/useAnimations';
import { useLanguage } from '../context/LanguageContext';
import { Calendar, Users, CheckCircle, Star } from 'lucide-react';

const stats = [
  { icon: <Calendar className="w-6 h-6" />, endValue: 19, suffix: '+', labelFr: 'Ans d\'expérience', labelEn: 'Years of Experience' },
  { icon: <Users className="w-6 h-6" />, endValue: 3000, suffix: '+', labelFr: 'Clients financés', labelEn: 'Clients Financed' },
  { icon: <CheckCircle className="w-6 h-6" />, endValue: 2800, suffix: '+', labelFr: 'Demandes traitées', labelEn: 'Applications Processed' },
  { icon: <Star className="w-6 h-6" />, endValue: 4.9, suffix: '/5', labelFr: 'Note Google', labelEn: 'Google Rating', isDecimal: true }
];

const StatItem = ({ stat }) => {
  const { language } = useLanguage();
  const endInt = stat.isDecimal ? 49 : stat.endValue;
  const { count, ref } = useCounter(endInt, 2000);
  const display = stat.isDecimal ? (count / 10).toFixed(1) : count.toLocaleString();

  return (
    <div ref={ref} className="text-center px-4">
      <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-white/10 flex items-center justify-center text-green-400">
        {stat.icon}
      </div>
      <div className="text-5xl md:text-6xl font-extrabold text-white tracking-tight">
        {display}<span className="text-green-400">{stat.suffix}</span>
      </div>
      <p className="text-sm md:text-base text-gray-400 mt-2 font-medium">
        {language === 'en' ? stat.labelEn : stat.labelFr}
      </p>
    </div>
  );
};

const StatsBar = () => {
  return (
    <section className="py-16 bg-[#0b130e]" data-testid="stats-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
          {stats.map((stat, i) => (
            <StatItem key={i} stat={stat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
